import React, { useEffect } from "react";

/**
 * ✅ Reusable Toast Component
 * Props:
 * - show (bool): Whether the toast is visible
 * - message (string): Toast message
 * - type (string): 'success' | 'error' | 'warning' | 'info'
 * - onClose (func): Function to close the toast
 */
export default function Toast({ show, message, type = "info", onClose }) {
  // ✅ Auto-dismiss after 3 seconds
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  // ✅ Background color based on toast type
  const typeClasses = {
    success: "bg-success text-white",
    error: "bg-danger text-white",
    warning: "bg-warning text-dark",
    info: "bg-info text-dark",
  };

  if (!show) return null;

  return (
    <div
      className={`toast align-items-center text-white border-0 position-fixed bottom-0 end-0 m-4 show ${typeClasses[type]}`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      style={{
        minWidth: "250px",
        zIndex: 1055,
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      }}
    >
      <div className="d-flex p-3">
        <div className="toast-body fw-semibold">
          {message}
        </div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          onClick={onClose}
        ></button>
      </div>
    </div>
  );
}
